import { render, staticRenderFns } from "./AddLocationPhotos.vue?vue&type=template&id=20bbc602&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddLocationPhotos.vue"
export default component.exports